"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
var store_const_1 = require("../../const/store.const");
var payload_1 = require("./payload");
exports.initialState = {
    STATUS: tslib_1.__assign({}, store_const_1.INITIAL_STATUS),
    data: [],
    error: null,
};
function setData(state, payload) {
    var _a = payload_1.getScopeAndValue(payload), scope = _a.scope, value = _a.value;
    if (scope) {
        state[scope].data = value;
    }
    else {
        state.data = value;
    }
}
exports.setData = setData;
function setError(state, payload) {
    var _a = payload_1.getScopeAndValue(payload), scope = _a.scope, value = _a.value;
    if (scope) {
        state[scope].error = value;
    }
    else {
        state.error = value;
    }
}
exports.setError = setError;
function setStatus(state, payload) {
    var _a = payload_1.getScopeAndValue(payload), scope = _a.scope, value = _a.value;
    var states;
    if (scope) {
        states = _.keys(state[scope].STATUS);
    }
    else {
        states = _.keys(state.STATUS);
    }
    if (_.includes(states, value)) {
        _.each(states, function (key) {
            var statusValue = key === value;
            if (scope) {
                state[scope].STATUS[key] = statusValue;
            }
            else {
                state.STATUS[key] = statusValue;
            }
        });
    }
}
exports.setStatus = setStatus;
